module.exports = __webpack_public_path__ + "img/check-circle.9a663fd2.svg";